/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *
 */

import { DEFAULT_LOCALE } from '../../utils/constants';

const enTranslationMessages = require('../../translations/en.json');
const iwTranslationMessages = require('../../translations/iw.json');
const bgTranslationMessages = require('../../translations/bg.json');
const deTranslationMessages = require('../../translations/de.json');
const ruTranslationMessages = require('../../translations/ru.json');
const arTranslationMessages = require('../../translations/ar.json');
const lvTranslationMessages = require('../../translations/lv.json');
const frTranslationMessages = require('../../translations/fr.json')

// prettier-ignore

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages) : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
  iw: formatTranslationMessages('iw', iwTranslationMessages),
  bg: formatTranslationMessages('bg', bgTranslationMessages),
  de: formatTranslationMessages('de', deTranslationMessages),
  ru: formatTranslationMessages('ru', ruTranslationMessages),
  ar: formatTranslationMessages('ar', arTranslationMessages),
  lv: formatTranslationMessages('lv', lvTranslationMessages),
  fr: formatTranslationMessages('fr', frTranslationMessages)
};

export { formatTranslationMessages, translationMessages, DEFAULT_LOCALE };
